"use client"

import { ArrowRight, CheckCircle2, Shield, Zap, Sparkles } from "lucide-react"
import { Button } from "@/shared/components/ui/button"

export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-background via-background to-muted/30">
      {/* Fondo cuadriculado sutil */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808008_1px,transparent_1px),linear-gradient(to_bottom,#80808008_1px,transparent_1px)] bg-[size:4rem_4rem]" />

      {/* Halos de profundidad animados */}
      <div className="absolute top-[-200px] right-[-200px] w-[800px] h-[800px] bg-primary/10 rounded-full blur-3xl animate-pulse-slow" />
      <div
        className="absolute bottom-[-100px] left-[-100px] w-[700px] h-[700px] bg-chart-4/10 rounded-full blur-3xl animate-pulse-slow"
        style={{ animationDelay: "1.2s" }}
      />

      {/* Elementos decorativos flotantes */}
      <div className="absolute top-24 left-16 w-20 h-20 border border-primary/20 rounded-xl rotate-12 animate-float" />
      <div
        className="absolute bottom-32 right-24 w-16 h-16 border border-chart-3/20 rounded-full animate-float"
        style={{ animationDelay: "0.6s" }}
      />

      {/* Contenido principal */}
      <div className="container relative mx-auto px-6 lg:px-10 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          {/* Texto */}
          <div className="space-y-8 animate-fade-in-up">
            {/* Badge superior */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary/10 to-chart-3/10 border border-primary/20 shadow-md shadow-primary/5 backdrop-blur-md">
              <Sparkles className="w-4 h-4 text-primary animate-pulse" />
              <span className="text-sm font-semibold bg-gradient-to-r from-primary to-chart-4 bg-clip-text text-transparent">
                Cumpliendo con la resolucion 2275
              </span>
            </div>

            {/* Título principal */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.1] tracking-tight text-balance">
              Facturación electrónica{" "}
              <span className="bg-gradient-to-r from-primary via-chart-3 to-chart-4 bg-clip-text text-transparent animate-gradient">
                fácil 
              </span>{" "}
              y {" "}
              <span className="bg-gradient-to-r from-primary via-chart-3 to-chart-4 bg-clip-text text-transparent animate-gradient">
                 segura
              </span>{" "}
              para el sector salud
            </h1>

            {/* Descripción */}
            <p className="text-lg lg:text-2xl text-muted-foreground leading-relaxed max-w-2xl">
              Solucion integral de facturación electronica y validacion RIPS Json. Cumple con la normativa colombiana sin complicaciones.
            </p>

            {/* Botones */}
            <div className="flex flex-col sm:flex-row gap-4 pt-3">
              <a
                href="https://app.rapyfact.com/register"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto"
              >
                <Button
                  size="lg"
                  className="bg-gradient-to-r from-primary to-chart-4 hover:from-primary/90 hover:to-chart-4/90 text-primary-foreground text-lg px-10 py-7 shadow-lg shadow-primary/25 hover:shadow-primary/40 transition-all duration-300 w-full sm:w-auto"
                >
                  ¡Pruebalo Ahora!
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </a>
            </div>

            {/* Características */}
            <div className="grid sm:grid-cols-2 gap-4 pt-8">
              <div className="flex items-start gap-3 p-4 rounded-xl bg-card/40 backdrop-blur-md border border-border/40 hover:border-primary/30 transition-all duration-300">
                <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-semibold text-foreground">Validación automática</div>
                  <div className="text-sm text-muted-foreground">RIPS 100% precisa</div>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 rounded-xl bg-card/40 backdrop-blur-md border border-border/40 hover:border-primary/30 transition-all duration-300">
                <Zap className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-semibold text-foreground">Integración rápida</div>
                  <div className="text-sm text-muted-foreground">Configuración en minutos</div>
                </div>
              </div>
            </div>
          </div>

          {/* Imagen derecha */}
          <div
            className="relative lg:pl-10 animate-fade-in-up"
            style={{ animationDelay: "0.3s" }}
          >
            <div className="relative aspect-[4/3] overflow-hidden hover:scale-[1.02] transition-transform duration-700">
  <img
    src="/images/image1.png"
    alt="Dashboard de facturación Rapyfact"
    className="w-full h-full object-contain"
  />
</div>


            {/* Tarjeta flotante */}
            <div className="absolute -bottom-6 -left-6 bg-card/90 backdrop-blur-md border border-border rounded-xl p-6 shadow-xl hidden lg:block max-w-xs ">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-primary/20 to-chart-3/20 flex items-center justify-center flex-shrink-0 shadow-inner">
                  <Shield className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground">Cumplimiento garantizado</div>
                  <div className="text-xs text-muted-foreground">Normativa DIAN actualizada</div>
                </div>
              </div>
            </div>

            {/* Insignia flotante */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-br from-chart-4 to-chart-3 text-white rounded-full p-4 shadow-lg hidden lg:block animate-bounce-slow">
              <Sparkles className="w-6 h-6" />
            </div>
          </div>
        </div>

        {/* Métricas inferiores */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 mt-20 lg:mt-32 pt-12 border-t border-border/50">
          {[
            { value: "100%", label: "Integracion Rips", gradient: "from-primary to-chart-3" },
            { value: "99.9%", label: "Disponibilidad", gradient: "from-chart-4 to-primary" },
            { value: "8/5", label: "Soporte técnico", gradient: "from-primary to-chart-4" },
            { value: "100%", label: "Cumplimiento DIAN", gradient: "from-chart-3 to-chart-4" },
          ].map((stat, i) => (
            <div key={i} className="text-center lg:text-left group">
              <div
                className={`text-4xl lg:text-5xl font-extrabold bg-gradient-to-r ${stat.gradient} bg-clip-text text-transparent mb-2 group-hover:scale-110 transition-transform`}
              >
                {stat.value}
              </div>
              <div className="text-sm lg:text-base text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
